import { Fragment, useState } from 'react';

import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  Healing,
  LocalPharmacyOutlined,
  DriveFileRenameOutline,
  MedicationOutlined,
  TaskOutlined,
  SentimentSatisfiedOutlined,
  RestaurantMenu,
  VerifiedUserOutlined,
  ExpandMore,
  MonitorHeartOutlined,
  MasksOutlined,
  BabyChangingStation,
  SickOutlined,
  DvrOutlined,
  PsychologyOutlined,
  LocalHotelOutlined,
  AssignmentTurnedInOutlined,
  VideocamOutlined,
  MedicalInformationOutlined,
  VideoLibraryOutlined,
  FeedOutlined,
  HubOutlined,
  ArticleOutlined,
} from '@mui/icons-material';

import { AiOutlineCalculator } from 'react-icons/ai';
import { BsCardChecklist } from 'react-icons/bs';
import { TbMessagePlus } from 'react-icons/tb';

import Survey from '../Survey';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRef: any;
}

type ActionMap = {
  [key: string]: () => void | Window | null;
};

const MenuRecords = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth, coachRef } = props;

  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  const menus = [
    {
      disabled: true,
      icon: <DvrOutlined />,
      label: '인수인계',
      id: 'taking_over',
    },
    {
      label: 'e-CARDEX',
      toggle: toggle.taking_over,
    },
    {
      label: '간호 인수인계',
      toggle: toggle.taking_over,
    },
    {
      label: 'SBAR',
      toggle: toggle.taking_over,
    },
    {
      isPro: true,
      label: 'SBAR2',
      toggle: toggle.taking_over,
    },
    {
      isPro: true,
      label: 'SBAR3',
      toggle: toggle.taking_over,
    },
    {
      disabled: true,
      icon: <Healing />,
      label: '입·퇴원 간호 기록지',
      id: 'adm_discharge',
    },
    {
      label: '입원간호 기록지',
      toggle: toggle.adm_discharge,
    },
    {
      label: '퇴원간호 기록지',
      toggle: toggle.adm_discharge,
    },
    {
      icon: <LocalPharmacyOutlined />,
      label: '환자상황 및 처방내역',
    },
    {
      icon: <DriveFileRenameOutline />,
      label: '간호 기록지',
    },
    {
      icon: <MedicationOutlined />,
      label: '투약 기록지',
    },
    {
      disabled: true,
      icon: <TaskOutlined />,
      label: '검사 기록지',
      id: 'inspection_record',
    },
    {
      label: '영상검사 기록지',
      toggle: toggle.inspection_record,
    },
    {
      label: '임상병리검사\n기록지',
      toggle: toggle.inspection_record,
    },
    {
      disabled: true,
      icon: <MonitorHeartOutlined />,
      label: '임상관찰 기록지',
      id: 'clinical_observation',
    },
    {
      label: '활력징후 기록지',
      toggle: toggle.clinical_observation,
    },
    {
      label: '섭취 및 배설량\n기록지',
      toggle: toggle.clinical_observation,
    },
    {
      label: '혈당 기록지',
      toggle: toggle.clinical_observation,
    },
    {
      isPro: true,
      label: '임상관찰 기록지(ICU)',
      toggle: toggle.clinical_observation,
    },
    {
      isPro: true,
      label: 'NEWS 2',
      toggle: toggle.clinical_observation,
    },
    {
      disabled: true,
      icon: <SentimentSatisfiedOutlined />,
      label: '환자평가/환자안전',
      id: 'patient_evaluation',
    },
    {
      label: '낙상위험\n평가도구 1',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: '낙상위험\n평가도구 2',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: '낙상위험\n평가도구 3',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: '소아 낙상위험\n평가',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '욕창위험\n평가도구 1',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: '욕창위험\n평가도구 2',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: '욕창위험\n평가도구 3',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: '욕창위험\n평가도구 4',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '욕구평가 기록지',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: 'GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: 'Pediatric GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: 'FOUR Score',
      toggle: toggle.patient_evaluation,
    },
    // {
    //   isPro: true,
    //   label: '고위험 신생아의\n성숙도 사정',
    //   toggle: toggle.patient_evaluation,
    // },
    {
      isPro: true,
      label: '환자안전사고\n보고서',
      toggle: toggle.patient_evaluation,
    },
    {
      isPro: true,
      label: '감염노출 보고서',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '환자안전보고\n학습시스템',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '의약품이상사례보고시스템',
      toggle: toggle.patient_evaluation,
    },
    {
      icon: <SickOutlined />,
      disabled: true,
      label: '통증평가도구',
      id: 'pain',
    },
    {
      label: 'NRS',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'FLACC Scale',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'CNPS',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'FFI',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'KOOS',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'LEFS',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'NDI',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'STarT Back\nScreening',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'K-CPAT',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'PAINAD-K\ncommunicative',
      toggle: toggle.pain,
    },
    {
      isPro: true,
      label: 'PAINAD-K\nnoncommunicative',
      toggle: toggle.pain,
    },
    {
      icon: <PsychologyOutlined />,
      disabled: true,
      isPro: true,
      label: '정신건강\n평가도구',
      id: 'mental_health',
    },
    {
      isPro: true,
      label: '정신간호 기록지',
      toggle: toggle.mental_health,
    },
    {
      isPro: true,
      label: 'MSE',
      toggle: toggle.mental_health,
    },
    {
      isPro: true,
      label: 'BDI',
      toggle: toggle.mental_health,
    },
    {
      isPro: true,
      label: 'BAI',
      toggle: toggle.mental_health,
    },
    {
      isPro: true,
      label: 'MMSE-K',
      toggle: toggle.mental_health,
    },
    {
      isPro: true,
      label: 'CIST',
      toggle: toggle.mental_health,
    },
    {
      isPro: true,
      label: 'KDSQ-P',
      toggle: toggle.mental_health,
    },
    {
      isPro: true,
      label: 'KDSQ-C',
      toggle: toggle.mental_health,
    },
    {
      isPro: true,
      disabled: true,
      icon: <MasksOutlined />,
      label: '특수파트 기록지',
      id: 'special',
    },
    {
      isPro: true,
      label: '수술 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '마취 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '수혈 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '혈액불출요청서',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '신체보호대 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '삽관 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '투석 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: 'CPR 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '응급 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '분만 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: '가정간호 기록지',
      toggle: toggle.special,
    },
    {
      isPro: true,
      label: 'ECMO 기록지',
      toggle: toggle.special,
    },
    {
      icon: <FeedOutlined />,
      label: '기타 기록지',
      isPro: true,
    },
    {
      isPro: true,
      disabled: true,
      icon: <LocalHotelOutlined />,
      label: '중증도 평가도구',
      id: 'severity',
    },
    {
      isPro: true,
      label: 'KPCS',
      toggle: toggle.severity,
    },
    {
      isPro: true,
      label: 'KPCSC',
      toggle: toggle.severity,
    },
    {
      isPro: true,
      label: 'KPCSN',
      toggle: toggle.severity,
    },
    {
      isPro: true,
      label: 'KPCS-GW',
      toggle: toggle.severity,
    },
    {
      isPro: true,
      label: 'KPCS-ICU',
      toggle: toggle.severity,
    },
    {
      isPro: true,
      label: 'KPCS-NICU',
      toggle: toggle.severity,
    },
    {
      isPro: true,
      label: '간호필요도',
      toggle: toggle.severity,
    },
    {
      isPro: true,
      icon: <RestaurantMenu />,
      label: '식이/영양\n기록지',
    },
    {
      isPro: true,
      disabled: true,
      icon: <VerifiedUserOutlined />,
      label: '동의서 1',
      id: 'agreement',
    },
    {
      isPro: true,
      label: '입원 안내 확인서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '입·퇴원 동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '자의퇴원서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '낙상 예방교육\n확인서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '수혈 동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: 'CRRT 동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '중심정맥삽관\n동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '기관내 삽관\n동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '대장내시경\n동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '상부내시경\n동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '신체보호대\n동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '비급여진료비\n동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '수술동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '진료기록 열람, \n사본발급 동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '사전연명의료\n의향서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '연명의료중단등결정\n환자가족 의사\n확인서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '유전자검사\n동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      label: '미성년자\n시술동의서',
      toggle: toggle.agreement,
    },
    {
      isPro: true,
      icon: <AssignmentTurnedInOutlined />,
      label: '동의서 2',
    },
    {
      isPro: true,
      icon: <BabyChangingStation />,
      label: '영유아 건강검진 문진',
    },
    {
      isPro: true,
      icon: <TbMessagePlus />,
      label: '간호과정기록지2',
    },
    {
      disabled: true,
      isPro: true,
      icon: <MedicalInformationOutlined />,
      label: '시뮬레이션 기록',
      id: 'simulation',
    },
    {
      label: '활동계획서',
      toggle: toggle.simulation,
    },
    {
      label: '간호과정 기록지',
      toggle: toggle.simulation,
    },
    {
      label: '개인정보 수집\n동의서',
      toggle: toggle.simulation,
    },
    {
      label: '디브리핑 기록지',
      toggle: toggle.simulation,
    },

    {
      disabled: true,
      icon: <MedicalInformationOutlined />,
      label: '간호정보학',
      id: 'medical_information',
    },
    {
      isPro: true,
      label: 'NEDIS',
      toggle: toggle.medical_information,
    },
    {
      label: '응급 모니터링시스템',
      toggle: toggle.medical_information,
    },
    {
      label: '보건의료빅데이터개방시스템',
      toggle: toggle.medical_information,
    },
    {
      label: '한국보건의료정보원',
      toggle: toggle.medical_information,
    },
    {
      label: '헬스맵',
      toggle: toggle.medical_information,
    },
    {
      label: 'Chat GPT',
      toggle: toggle.medical_information,
    },
    {
      label: 'Google Gemini',
      toggle: toggle.medical_information,
    },
    {
      label: 'CLOVA X',
      toggle: toggle.medical_information,
    },
    {
      label: '간호실무지침',
      toggle: toggle.medical_information,
    },
    {
      label: '나의 건강관리',
      toggle: toggle.medical_information,
    },
    {
      label: 'Cochranelibrary',
      toggle: toggle.medical_information,
    },
    {
      label: 'JBI',
      toggle: toggle.medical_information,
    },
    {
      label: 'DXPLAIN',
      toggle: toggle.medical_information,
    },
    {
      label: 'Patientslikeme',
      toggle: toggle.medical_information,
    },
    {
      label: 'Smartpatients',
      toggle: toggle.medical_information,
    },
    // {
    //   disabled: true,
    //   isPro: true,
    //   icon: <AiOutlineCalculator />,
    //   label: 'Calc & Scale',
    //   id: 'calc_scale',
    // },
    // {
    //   isPro: true,
    //   label: '약물계산기',
    //   toggle: toggle.calc_scale,
    // },
    // {
    //   isPro: true,
    //   label: 'Medcalc',
    //   toggle: toggle.calc_scale,
    // },
    // {
    //   isPro: true,
    //   label: '의학계산기',
    //   toggle: toggle.calc_scale,
    // },
    {
      disabled: true,
      isPro: true,
      icon: <BsCardChecklist />,
      label: '간호기록체크리스트',
      id: 'nurse_record',
    },
    {
      isPro: true,
      label: '병동',
      toggle: toggle.nurse_record,
    },
    {
      isPro: true,
      label: '응급실',
      toggle: toggle.nurse_record,
    },
    {
      isPro: true,
      label: '수술실',
      toggle: toggle.nurse_record,
    },
    {
      isPro: true,
      icon: <ArticleOutlined />,
      label: '과제 제출',
    },
    {
      disabled: true,
      isPro: true,
      icon: <VideoLibraryOutlined />,
      label: '핵심간호술기영상 예시',
      id: 'video_example',
    },
    {
      isPro: true,
      label: '예시1 (수문사)',
      toggle: toggle.video_example,
    },
    {
      isPro: true,
      label: '예시2 (현문사)',
      toggle: toggle.video_example,
    },
    {
      isPro: true,
      label: '예시3 (알엔지야)',
      toggle: toggle.video_example,
    },
    {
      isPro: true,
      label: '예시4 (대한나래)',
      toggle: toggle.video_example,
    },
    {
      isPro: true,
      label: '예시5 (투약간호)',
      toggle: toggle.video_example,
    },
    {
      isPro: true,
      disabled: true,
      icon: <HubOutlined />,
      label: '간호 AI',
      id: 'ai',
    },
    {
      isPro: true,
      label: 'SmartENR AI',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: 'AI 튜터',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: 'E-널싱',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: '마이메르시',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: '듀팅',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: '듀티메이트',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: 'Duty Maker',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: 'Duty Flow',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: '오토스케쥴365',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: '하루듀티',
      toggle: toggle.ai,
    },
    {
      isPro: true,
      label: 'Voice EMR',
      toggle: toggle.ai,
    },
  ];

  const actionMap: ActionMap = {
    '영유아 건강검진 문진': () => window.open('/#/badyMedicalCheckup'),
    NEDIS: () =>
      window.open('https://portal.nemc.or.kr:444/member/login_page.do'),
    '환자안전보고\n학습시스템': () =>
      window.open('https://statistics.kops.or.kr/biWorks/dashBoardMain.do'),
    의약품이상사례보고시스템: () =>
      window.open(
        'https://www.drugsafe.or.kr/iwt/ds/ko/report/WhatIsKAERS.do;jsessionid=aOUQlS7Cufvit9aLo8fGQHfXD1KflOcDMmW19GIp0Tc3b5AdbDZ1TqaXK5W7lYAQ.webint_2_servlet_engine1'
      ),
    '응급 모니터링시스템': () =>
      window.open('http://dw.nemc.or.kr/nemcMonitoring/mainmgr/Main.do'),
    보건의료빅데이터개방시스템: () =>
      window.open('https://opendata.hira.or.kr/home.do'),
    한국보건의료정보원: () => window.open('https://www.k-his.or.kr/'),
    'ICNP brower': () => window.open('https://www.icn.ch/icnp-browser'),
    'Chat GPT': () => window.open('https://chat.openai.com/chat'),
    'Google Gemini': () => window.open('https://bard.google.com/'),
    'CLOVA X': () => window.open('https://clova-x.naver.com'),
    'Duty Maker': () => window.open('https://dutymaker.com/landing/'),
    'Duty Flow': () => window.open('https://dutyflow.co.kr/'),
    오토스케쥴365: () => window.open('https://autoschedule365.com/'),
    하루듀티: () => window.open('https://www.haruduty.com/'),
    '학생 기록 관리': () => window.open('/#/coreSkillVideo'),
    'AI 튜터': () => window.open('https://tutor.o2ai.co.kr/xid/'),
    'E-널싱': () => window.open('https://www.fornurse.kr/main/index.jsp'),
    마이메르시: () => window.open('https://mymerci.kr/landing/index.php'),
    듀팅: () => window.open('https://www.dutying.net/'),
    듀티메이트: () => window.open('https://dutymate.net/'),
    'SmartENR AI': () => window.open('https://chatbot2-enr.streamlit.app/'),
    '동의서 2': () => window.open('/#/agreement2'),
    헬스맵: () => window.open('https://www.healthmap.or.kr/'),
    간호실무지침: () =>
      window.open('https://khna.or.kr/home/pds/practiceGuidelines.php'),
    '나의 건강관리': () =>
      window.open(
        'https://www.nhis.or.kr/nhis/healthin/retrieveMyHealthCareInfo.do'
      ),
    Cochranelibrary: () => window.open('https://www.cochranelibrary.com/'),
    JBI: () => window.open('https://jbi.global/'),
    DXPLAIN: () => window.open('https://www.mghlcs.org/projects/dxplain'),
    Patientslikeme: () => window.open('https://www.patientslikeme.com/'),
    Smartpatients: () => window.open('https://www.smartpatients.com/'),
    Medcalc: () => window.open('http://medcalc.ajoumc.or.kr/'),
    의학계산기: () => window.open('https://medcalc.co.kr/'),
    '예시5 (투약간호)': () =>
      window.open('https://www.connectdi.com/cont/medicine_guide/?'),
  };

  const onClickListItem = (label: string) => {
    const action = actionMap[label];

    if (!action) {
      if (!student_uuid) return onRequired('REQUIRED.STUDENT');

      if (!patientInfo) {
        return onRequired('REQUIRED.PATIENT');
      }
      onUpdateSurveyType(label);
      return;
    }
    action();
  };

  const onClickDisabledItem = (sublabel: string | undefined) => {
    let newToggle = { ...toggle };

    if (menuDrawerWidth !== 300) {
      if (sublabel) newToggle[sublabel] = true;
      setToggle(newToggle);
      setMenuDrawerWidth(300);
      return;
    }

    if (sublabel) newToggle[sublabel] = !newToggle[sublabel];
    setToggle(newToggle);
  };

  return (
    <Fragment>
      {menus.map(({ icon, label, disabled, toggle, id }) => {
        const onClick = () => {
          if (disabled) onClickDisabledItem(id);
          else onClickListItem(label);
        };

        const MoreIcon = () => {
          if (!disabled) return null;
          return <ExpandMore fontSize="small" sx={{ color: '#fff' }} />;
        };

        if (disabled) {
          return (
            <>
              {icon ? (
                <ListItem
                  key={label}
                  disablePadding
                  ref={label === 'Special part Record' ? coachRef : null}
                  sx={{ whiteSpace: 'pre-wrap' }}
                >
                  <ListItemButton
                    onClick={onClick}
                    sx={{
                      display: 'block',
                      width: '80px',
                      height: '80px',
                      padding: '0px',
                      alignItems: 'center',
                      borderRadius: '8px',
                      margin: '7px',
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        margin: '6.5px 0 6px 0',
                        justifyContent: 'center',
                        width: '80px',
                      }}
                    >
                      {icon}
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                      }}
                      primary={label}
                    />
                  </ListItemButton>
                </ListItem>
              ) : toggle ? (
                <ListItem key={label} disablePadding>
                  <ListItemButton
                    onClick={onClick}
                    sx={{
                      display: 'block',
                      width: '80px',
                      height: '80px',
                      padding: '0px',
                      alignItems: 'center',
                      borderRadius: '8px',
                      margin: '7px',
                    }}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                      }}
                      primary={label}
                      sx={{ whiteSpace: 'pre-wrap' }}
                    />
                  </ListItemButton>
                </ListItem>
              ) : (
                <></>
              )}
            </>
          );
        }

        return (
          <>
            {icon ? (
              <ListItem
                key={label}
                disablePadding
                ref={label === 'Special part Record' ? coachRef : null}
                sx={{ whiteSpace: 'pre-wrap' }}
              >
                <ListItemButton
                  onClick={onClick}
                  sx={{
                    display: 'block',
                    width: '80px',
                    height: '80px',
                    padding: '0px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '7px',
                  }}
                >
                  <ListItemIcon
                    sx={{
                      margin: '6.5px 0 6px 0',
                      justifyContent: 'center',
                      width: '80px',
                      '&:hover': {
                        color: 'red',
                      },
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{
                      fontSize: '12px',
                      textAlign: 'center',
                    }}
                    primary={label}
                  />
                </ListItemButton>
              </ListItem>
            ) : toggle ? (
              <ListItem
                key={label}
                disablePadding
                sx={{
                  width:
                    label === 'Patient\nSafety Reporting\nand Learning System'
                      ? '120px'
                      : label === 'Adverse Drug Reaction \nReporting System'
                      ? '150px'
                      : '100px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                <ListItemButton
                  onClick={onClick}
                  sx={{
                    display: 'block',
                    width:
                      label === 'Patient\nSafety Reporting\nand Learning System'
                        ? '120px'
                        : label === 'Adverse Drug Reaction \nReporting System'
                        ? '150px'
                        : '100px',
                    height: '80px',
                    padding: '0px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '7px',
                    backgroundColor: 'white',
                    ':hover': {
                      boxShadow: '1px 0px 3px 0px #E2E2E2',
                      borderRadius: '8px',
                    },
                  }}
                >
                  <div
                    style={{
                      height: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'white',
                      marginTop: '-0.5px',
                      borderRadius: '8px',
                    }}
                  >
                    <ListItemText
                      className="DropMenu"
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                        fontWeight: 500,
                      }}
                      primary={label}
                    />
                  </div>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}
          </>
        );
      })}

      <Survey />
    </Fragment>
  );
};

export default MenuRecords;
